<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{donneeAnalyse.referentielDonneeAnalyse.nom| translate}}
    {{donneeAnalyse.referentielDonneeAnalyse.nomUniteReferentiel ? ' (' + donneeAnalyse.referentielDonneeAnalyse.nomUniteReferentiel + ')' : ''}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    @if (donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'string') {
      <div class="form-group">
        <textarea #inputString [(ngModel)]="donneeAnalyse.valeur" name="{{ 'input_' + donneeAnalyse.donneeAnalyseId}}" id="{{ 'input_' + donneeAnalyse.donneeAnalyseId}}"
          class="form-control not-resizable" placeholder="{{donneeAnalyse.referentielDonneeAnalyse.nom | translate}}" style="width:100%;" rows="5">
        </textarea>
      </div>
    }

    @if (donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'number') {
      <div class="form-group">
        <input #inputNumber type="number" [(ngModel)]="donneeAnalyse.valeur" name="{{ 'input_' + donneeAnalyse.donneeAnalyseId}}" id="{{ 'input_' + donneeAnalyse.donneeAnalyseId}}"
          class="form-control col-md-6 offset-md-3" placeholder="Entrez un nombre" min="{{valeurMinNb()}}" max="{{valeurMaxNb()}}" />
          @if (donneeAnalyse.enErreur) {
            <div class="custom-alert custom-alert-sm">{{'MODALE_DONNEE_ANALYSE.VALEUR_HORS_INTERVAL' | translate:{minValue: valeurMinNb(), maxValue:valeurMaxNb()} }}</div>
          }
        </div>
      }

      @if (donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'boolean') {
        <div class="form-group d-flex justify-content-between">
          <div class="form-check form-check-inline w-100">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="rdBtnOui" value="true" [(ngModel)]="donneeAnalyse.valeur">
            <label class="form-check-label not-selectable w-100" for="rdBtnOui">{{'GLOBAL.OUI' | translate}}</label>
          </div>
          <div class="form-check form-check-inline w-100">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="rdBtnNon" value="false" [(ngModel)]="donneeAnalyse.valeur">
            <label class="form-check-label not-selectable  w-100" for="rdBtnNon">{{'GLOBAL.NON' | translate}}</label>
          </div>
          <div class="form-check form-check-inline w-100">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="rdBtnNull" value="" [(ngModel)]="donneeAnalyse.valeur">
            <label class="form-check-label not-selectable w-100" for="rdBtnNull">{{'GLOBAL.NON_RENSEIGNE' | translate}}</label>
          </div>
        </div>
      }
      @if (erreurApi()) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
      }
      <div class="btn-toolbar justify-content-between">
        <div class="btn-group" role="group">
          <button type="submit" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
        </div>
      </div>
    </form>
  </div>

  <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="custom-overlay"></div>
        <div class="modal-body text-center">
          <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
          <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
